import React from 'react';
import { ActionIcon, Card, Text, useMantineTheme, Menu, Group, SimpleGrid } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { getPropInSubLevelRole, getPropInLevelRole } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import SortSegmentedControl from "../../components/general/SortSegmentedControl";

const SUDataUserCard = ({ stateData, stateSortList, stateSortSelected, fnSort, fnSelectedDataEdit, fnSelectedDataReset, fnSelectedDataDelete, fnSelectedDataView }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>

            <SortSegmentedControl
                stateSortList={stateSortList}
                stateSortSelected={stateSortSelected}
                fnSort={fnSort}
                stateStyle={{ marginBottom: theme.spacing.md }}
            />

            <SimpleGrid
                cols={1}
                spacing='md'
                breakpoints={[
                    { minWidth: 'xl', cols: 4, spacing: 'md' },
                    { minWidth: 'lg', cols: 3, spacing: 'md' },
                    { minWidth: 'md', cols: 2, spacing: 'md' },
                    { minWidth: 'sm', cols: 2, spacing: 'md' },
                    { minWidth: 'xs', cols: 2, spacing: 'md' },
                ]}
            >
                {Object.keys(stateData).map((key, index) => {
                    return (
                        <Card
                            key={key}
                            shadow=''
                            radius="sm"
                            withBorder={true}

                            style={{
                                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                overflow: 'unset',
                                cursor: 'pointer',
                            }}

                            onClick={() => {
                                fnSelectedDataView(stateData[key]);
                            }}
                        >
                            <Card.Section p='sm'>
                                <Text size="sm">
                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.userName.caption}
                                        stateContent={<Group position='apart' noWrap>
                                            <Text lineClamp={2}>{stateData[key].user_name}</Text>

                                            <Menu shadow="md" width={200}>
                                                <Menu.Target>
                                                    <ActionIcon
                                                        size='md'
                                                        variant="subtle"
                                                        radius='xl'

                                                        sx={{
                                                            '&:hover': {
                                                                backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[5]
                                                            },
                                                        }}

                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <IconDotsVertical size='1rem' />
                                                    </ActionIcon>
                                                </Menu.Target>

                                                <Menu.Dropdown>
                                                    <Menu.Item
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            fnSelectedDataEdit(stateData[key]);
                                                        }}
                                                    >
                                                        Edit Data
                                                    </Menu.Item>

                                                    <Menu.Divider />

                                                    <Menu.Item
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            fnSelectedDataReset(stateData[key]);
                                                        }}
                                                    >
                                                        Edit Username & Password
                                                    </Menu.Item>

                                                    <Menu.Divider />

                                                    <Menu.Item
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            fnSelectedDataDelete(stateData[key])
                                                        }}
                                                    >
                                                        Delete
                                                    </Menu.Item>
                                                </Menu.Dropdown>
                                            </Menu>
                                        </Group>}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.userGender.caption}
                                        stateContent={stateData[key].user_gender === '1' ? 'Pria' : 'Wanita'}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.userLevel.caption}
                                        stateContent={getPropInLevelRole(stateData[key].user_level, 'caption', '-')}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.userSubLevel.caption}
                                        stateContent={getPropInSubLevelRole(stateData[key].user_sub_level, 'caption', '-')}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.userIsActive.caption}
                                        stateContent={stateData[key].user_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                                        stateDivider={false}
                                    />
                                </Text>
                            </Card.Section>
                        </Card>
                    )
                })}
            </SimpleGrid>
        </React.Fragment>
    )
}

export default React.memo(SUDataUserCard);